module.exports = __webpack_public_path__ + "static/engagement-score-b8256fa79346f4aa14aeaa93cf860275.png";